import type { TextShortcut } from "../../types.ts";
import { shortcutPreview } from "../Shortcuts.helpers.ts";
import { scopeLabel } from "./formatters.ts";

type ShortcutCardProps = {
  shortcut: TextShortcut;
  active: boolean;
  canDelete: boolean;
  canInsert: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onInsert: () => void;
  onCopy: () => void;
};

export function ShortcutCard({
  shortcut,
  active,
  canDelete,
  canInsert,
  onEdit,
  onDelete,
  onInsert,
  onCopy,
}: ShortcutCardProps) {
  return (
    <article className={`shortcut-card ${active ? "is-active" : ""}`}>
      <button className="shortcut-card-main" type="button" onClick={onEdit}>
        <span className="shortcut-trigger">{shortcut.trigger}</span>
        <span className="shortcut-title">{shortcut.title || shortcut.trigger}</span>
        <span className="shortcut-card-preview">{shortcutPreview(shortcut)}</span>
      </button>
      <div className="shortcut-card-actions">
        <span className={`shortcut-scope scope-${shortcut.scope}`}>{scopeLabel(shortcut.scope)}</span>
        <button className="btn btn-secondary btn-compact" type="button" disabled={!canInsert} onClick={onInsert}>
          Inserir
        </button>
        <button className="btn btn-secondary btn-compact" type="button" onClick={onCopy}>
          Copiar
        </button>
        {canDelete ? (
          <button className="btn btn-danger btn-compact" type="button" onClick={onDelete}>
            Remover
          </button>
        ) : null}
      </div>
    </article>
  );
}
